import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import Hero from "./sections/Hero";
import Pricing from "./sections/Pricing";
import Features from "./sections/Features";
import Services from "./sections/Services";
import About from "./sections/About";
import Testimonials from "./sections/Testimonials";
import FAQ from "./sections/FAQ";
import TechStack from "./sections/TechStack";
import Contact from "./sections/Contact";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <AnimatePresence mode="wait">
        {!loading && (
          <motion.div
            key="main-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            className="min-h-screen"
            style={{ background: "var(--navy)" }}
          >
            <Navbar />
            <main>
              <Hero />
              <Features />
              <Pricing />
              <Services />
              <Testimonials />
              <FAQ />
              <About />
              <TechStack />
              <Contact />
            </main>
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default App;
